import { dummyCaptains } from "src/constants/dummyCaptains";
import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setCaptainsList } from "src/reducers/captains";

export const getCaptainsListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(
        `/api/v1/admin/captains?${query}`
      );

      // ✅ fallback if empty
      if (!res?.data?.result?.data?.length) {
        dispatch(setCaptainsList(dummyCaptains));
        return dummyCaptains;
      }

      dispatch(setCaptainsList(res.data));
      return res.data;
    } catch (err) {
      console.log("🔥 Using dummy captains");
      dispatch(setCaptainsList(dummyCaptains));
      return dummyCaptains;
    }
  };

export const updateCaptainStatusAction: any =
  (payload) => async () => {
    const res = await instance.patch(`/Admin/captains/status`, payload);
    return res.data;
  };

export const deleteCaptainAction: any =
  (id) => async () => {
    const res = await instance.delete(`/api/v1/admin/captains/${id}`);
    return res.data;
  };

export const updateDocumentStatusAction: any =
  (payload) => async () => {
    const res = await instance.patch(
      `/api/v1/admin/captains/document/status`,
      payload
    );
    return res.data;
  };